// extracted by mini-css-extract-plugin
export var content = "_px-1";
export var fullScreen = "_px-0";